/*  hp-info-selector

    Swaps the visible panel when a pill is chosen. Nothing else — this block is
    informational, so it deliberately does not touch the variant, the form or
    the price.

    Panels are hidden rather than removed. Keeping them in the DOM means the
    text is already there when a pill is clicked, with no reflow on switch, and
    it leaves the markup addressable if anything ever needs to read it.

    Guarded so it is safe to load twice — the theme editor re-renders sections
    on every settings change, and a second definition of the same custom
    element would throw.  */
if (!customElements.get('hp-info-selector')) {
  customElements.define(
    'hp-info-selector',
    class HpInfoSelector extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-hp-infosel-panel]'));
        this.inputs = Array.from(this.querySelectorAll('[data-hp-infosel-input]'));

        if (!this.panels.length || !this.inputs.length) return;

        /*  One listener on the element rather than one per input: the editor
            can add or remove options without this needing to rebind.  */
        this.addEventListener('change', this.onChange);

        /*  Sync once on load. The checked attribute is set server side, but a
            browser restoring form state on a back-navigation can land on a
            different pill than the one Liquid marked.  */
        const checked = this.inputs.find((i) => i.checked);
        if (checked) this.show(checked.value);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange = (event) => {
        const input = event.target.closest('[data-hp-infosel-input]');
        if (input) this.show(input.value);
      };

      show(value) {
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.hpInfoselPanel !== String(value);
        });
      }
    }
  );
}
